// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_e6-2";
export var aiChatCartContainerExit = "_e6-4";
export var aiChatContainerLarge = "_e6-0";
export var aiChatContainerSmall = "_e6-1";
export var aiChatIcon = "_e6-6";
export var slideInFromRight = "_e6-3";
export var slideOutToRight = "_e6-5";